module.exports = __webpack_public_path__ + "static/backgroundBannerCursos-50cbcb36f2895ec6f0da59a3a39a5493.jpg";